import styled from "styled-components";
import { TextField } from "@material-ui/core";

export const STTextField = styled(TextField)`
  && {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;
